import Header from "../component/header";
import Footer from "../component/footer";
import Lenis from 'lenis'
import ContactForm from "../component/contac-form"

function Contact() {

        
    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

    return (
<main>
   <Header/>


    <div id="smooth-wrapper">
        <div id="smooth-content">
            {/* <!-- Add your site or application content here --> */}
            <main>

                {/* <!-- Contact area start --> */}
                        <ContactForm/>
                {/* <!-- Contact area end --> */}

                {/* <!-- location map area start --> */}
                {/* <div className="location-map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d188910.2277348383!2d-0.264174663336833!3d51.52985941123778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sbd!4v1677566276830!5m2!1sen!2sbd"></iframe>
                </div> */}
                {/* <!-- location map area end --> */}

            </main>

          <Footer/>
        </div>
    </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
      </main>
)}

export default Contact;

